import { useWindowDimensions } from 'react-native';
import { Platform } from 'react-native';
import { env } from './env';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export function useDevice() {
  const { width } = useWindowDimensions();
  let widthBreakpoint: Breakpoint = 'xs';

  if (width > 1280) {
    widthBreakpoint = 'xl';
  } else if (width > 1024) {
    widthBreakpoint = 'lg';
  } else if (width > 768) {
    widthBreakpoint = 'md';
  } else if (width > 640) {
    widthBreakpoint = 'sm';
  }

  return {
    version: env.APP_VERSION || '0.0.0',
    platform: Platform.OS,
    md: 768,
    wizardWidth: Math.min(width, 768),
    width,
    widthBreakpoint,
    widerThanMd: widthBreakpoint === 'md' || widthBreakpoint === 'lg' || widthBreakpoint === 'xl',
  };
}
